import { useState } from 'react'
import AdminHeader from './AdminHeader.js'
import NoDataFound from '../components/NoDataFound.js'
import { GET_FRANCHISE_INQUIRY } from '../graphql/Query/GETALLFRANCHISELIST.js';
import { useQuery } from '@apollo/client';
import Table from "../components/Table/index.jsx";
import moment from 'moment';

const AdminFranchiseEnquiry = () => {
    const [page, setPage] = useState(1);
    const [limit, setLimit] = useState(10);
    const { data, loading } = useQuery(GET_FRANCHISE_INQUIRY, {
        variables: {
            page: page,
            limit,
            sort: {
                key: "createdAt",
                type: -1
            },
            // filter: filter,
            // from: finalRange?.startDate?.toISOString(), // Use updated startDate
            // to: finalRange?.endDate?.toISOString(),
            // status: active,
            // ticketstatus: selectedStatus,
            // tickettype: selectedType,
        },
        fetchPolicy: 'cache-and-network'
    });
    const handlePagination = (page) => {
        // console.log('✌️page --->', page);
        // setLoader(true);
        setPage(page?.selected);
    };


    const franchiseInquiryColumns = (page, limit) => [
        {
            name: "No.",
            sortable: false,
            width: "80px",
            cell: (row, index) => index + 1 + ((page - 1) * limit),
        },
        {
            name: "Date",
            sortable: true,
            selector: (row) => moment(row?.createdAt).format("DD/MM/YYYY"),
            width: "140px",
        },
        {
            name: "Full Name",
            sortable: true,
            selector: (row) => row?.fullName,
            width: "200px",
            cell: (row) => <span className="font-medium text-gray-800">{row?.fullName}</span>,
        },
        {
            name: "Contact No",
            sortable: true,
            selector: (row) => row?.contactNo,
            width: "160px",
        },
        {
            name: "Preferred Area",
            sortable: true,
            selector: (row) => row?.preferredArea,
            width: "200px",
        },
        {
            name: "Pincode",
            sortable: true,
            selector: (row) => row?.pincode,
            width: "120px",
        },
        {
            name: "City",
            sortable: true,
            selector: (row) => row?.city,
            width: "160px",
        },
        {
            name: "Message",
            sortable: false,
            selector: (row) => row?.message || "-",
            minWidth: "250px",
            cell: (row) => (
                <div className="truncate max-w-[250px]" title={row?.message}>
                    {row?.message || "-"}
                </div>
            ),
        },
        {
            name: "Status",
            sortable: true,
            selector: (row) => row?.status,
            width: "160px",
            cell: (row) => {
                const statusColors = {
                    Pending: "bg-yellow-100 text-yellow-700 border border-yellow-300",
                    Contacted: "bg-blue-100 text-blue-700 border border-blue-300",
                    Converted: "bg-green-100 text-green-700 border border-green-300",
                    Rejected: "bg-red-100 text-red-700 border border-red-300",
                };

                return (
                    <span
                        className={`px-4 py-1 rounded-md text-xs font-semibold uppercase tracking-wide ${statusColors[row?.status] || "bg-gray-200 text-gray-800 border border-gray-300"}`}
                    >
                        {row?.status}
                    </span>
                );
            },
        },
    ];
    return (
        <>
            {/* <AdminHeader /> */}
            <div className="text-gray-600 grid grid-cols-1 border rounded-lg p-2">
                <p className="font-semibold mb-3">Total: {data?.getAllFranchiseInquiries?.count}</p>
                {data?.getAllFranchiseInquiries?.data?.length > 0 ? (
                    <Table
                        columns={franchiseInquiryColumns(page, limit)}
                        data={data?.getAllFranchiseInquiries?.data || []}
                        currentPage={page}
                        totalRecords={data?.getAllFranchiseInquiries?.count || 0}
                        limit={limit}
                        setLimit={setLimit}
                        setPage={setPage}
                        loading={loading}
                        handlePagination={handlePagination}
                    />
                ) : (
                    <NoDataFound />
                )}
            </div>

        </>
    )
}

export default AdminFranchiseEnquiry
